export default __webpack_public_path__ + "700fa7e0d2d2a16f6e3e4b2f07c64fc0.svg";